import React, { ComponentProps } from "react";

export default function LoveSolidIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="mask0_297_362655"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_297_362655)">
        <path
          d="M11.994 20.5042C11.7248 20.5042 11.4545 20.4557 11.183 20.3585C10.9113 20.2612 10.6699 20.1089 10.4588 19.9017L8.72175 18.3147C6.96309 16.7099 5.36925 15.1047 3.94025 13.4992C2.51125 11.8936 1.79675 10.1105 1.79675 8.14998C1.79675 6.52348 2.33967 5.16532 3.4255 4.07549C4.51134 2.98565 5.8675 2.44073 7.494 2.44073C8.36934 2.44073 9.19667 2.61923 9.976 2.97623C10.7553 3.3334 11.428 3.82899 11.994 4.46299C12.56 3.82899 13.2327 3.3334 14.012 2.97623C14.7913 2.61923 15.6187 2.44073 16.494 2.44073C18.1205 2.44073 19.4797 2.98565 20.5715 4.07549C21.6633 5.16532 22.2093 6.52348 22.2093 8.14998C22.2093 10.1105 21.4959 11.8977 20.0693 13.5117C18.6426 15.1256 17.0333 16.7369 15.2413 18.3457L13.5353 19.9075C13.3241 20.1148 13.0818 20.2662 12.8083 20.3615C12.5346 20.4567 12.2632 20.5042 11.994 20.5042Z"
          fill={props.fill ?? "white"}
        />
      </g>
    </svg>
  );
}
